import z from "zod";

import { Button } from "@shared/content-types/schemas/common.schema";

export const CulturalObjectMapSchema = z.object({
  isVisible: z.boolean().default(true),
  title: z.string().optional(),
  ctaButton: Button.base.optional(),
});

export type CulturalObjectMapType = z.infer<typeof CulturalObjectMapSchema>;
